import { DEFAULT_SUBJECT, isValidSubjectCode, type SubjectCode } from './subjectConfig';

export const ACTIVE_SUBJECT_STORAGE_KEY = 'lec_last_subject';
export const TTQ_SUBJECT_STORAGE_KEY = 'ttq_last_subject';

let memorySubject: SubjectCode = DEFAULT_SUBJECT;

export function getMemoryActiveSubject(): SubjectCode {
  return memorySubject;
}

export function readPersistedActiveSubject(): SubjectCode {
  try {
    for (const key of [ACTIVE_SUBJECT_STORAGE_KEY, TTQ_SUBJECT_STORAGE_KEY]) {
      const saved = localStorage.getItem(key);
      if (saved && isValidSubjectCode(saved)) {
        memorySubject = saved;
        return saved;
      }
    }
  } catch {
    // ignore storage errors
  }
  return memorySubject;
}

export function persistActiveSubject(code: SubjectCode): void {
  memorySubject = code;
  try {
    localStorage.setItem(ACTIVE_SUBJECT_STORAGE_KEY, code);
    localStorage.setItem(TTQ_SUBJECT_STORAGE_KEY, code);
  } catch {
    // ignore storage errors
  }
}
